'use client';

import { ComponentProps } from 'react';
import { FieldPath, FieldValues, useController } from 'react-hook-form';

import * as Field from '@/ui/Field';

export type TextFieldProps<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<ComponentProps<typeof Field.Input>, 'name'> & {
    name: TName;
    label?: string;
};

export function TextField<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, label, required, ...props }: TextFieldProps<TFieldValues, TName>) {
    const controller = useController({
        name,
    });

    const { error } = controller.fieldState;

    return (
        <Field.Root name={name} error={error?.message} required={required}>
            {label && <Field.Label>{label}</Field.Label>}
            <Field.Input
                {...props}
                {...controller.field}
                value={controller.field.value ?? ''}
            />
            <Field.Error />
        </Field.Root>
    );
}
